import { createRouter, createWebHistory } from "vue-router";
import Inicio from "../views/Inicio.vue";
import Termos from "../views/Termos.vue";
import Verificacao from "../views/Verificacao.vue";
import ConfirmarCodigo from "../views/ConfirmarCodigo.vue";
import PageNotFound from "../views/PageNotFound.vue";

const routes = [
  {
    path: "/",
    name: "Inicio",
    component: Inicio,
  },
  {
    path: "/termos",
    name: "Termos",
    component: Termos,
  },
  {
    path: "/verificacao",
    name: "Verificacao",
    component: Verificacao
  },
  {
    path: "/confirmacao",
    name: "ConfirmarCodigo",
    component: ConfirmarCodigo
  },
  {
    // path: "*",
    path: "/:catchAll(.*)",
    name: "PageNotFound",
    component: PageNotFound,
    meta: {
      requiresAuth: false
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
